import {TokenService as Service} from '../TokenService';

import {useDialogCrup} from '../../../../shared/hooks/DialogCrup';

export const ChangePassword = ({header, dataKey, refreshLazyData}) => {

  const {render, update} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {field: 'passwordCer', header: 'Mật khẩu hiện tại', required: true, InputTextProps: {maxLength: 50, type: 'password'}, className: 'md:col-12'},
      {field: 'newPassword', header: 'Mật khẩu mới', required: true, InputTextProps: {maxLength: 50, type: 'password'}, className: 'md:col-12'},
      {field: 'newPasswordConfirm', header: 'Xác nhận mật khẩu', required: true, InputTextProps: {maxLength: 50, type: 'password'}, className: 'md:col-12'}
    ],
    updateItem: (id, item) => {
      item.id = id;
      return Service.changePass(item);
    },
    refreshLazyData
  });

  return {render, open: update};

}